// accordion.js — one toggle for every button[data-accordion-target]; targets are section/block-scoped ids.
const toggleAccordion = (button) => {
  const target = document.querySelector(
    button.getAttribute('data-accordion-target'),
  );
  if (!target) {
    if (isDev) {
      console.warn(
        'Accordion target not found',
        button.getAttribute('data-accordion-target'),
      );
    }
    return;
  }
  const expanded = button.getAttribute('aria-expanded') === 'true';
  target.classList.toggle('hidden', expanded);
  button.setAttribute('aria-expanded', String(!expanded));
  button
    .querySelector('[data-accordion-icon]')
    ?.classList.toggle('rotate-180', !expanded);
  // Panel was hidden at DOMContentLoaded, so any carousel inside it inits at zero width; re-init now it's visible.
  if (!expanded) window.initCarousels?.(target);
};

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('button[data-accordion-target]')
    .forEach((button) => {
      button.addEventListener('click', () => toggleAccordion(button));
    });
});
